import React, { useEffect } from 'react';
import { Modal, Form, Radio, Button, message } from 'antd';
import './index.scss';

// 考生信息类型
export interface StudentInfo {
  examNo: string;
  name: string;
  phone: string;
  mobile: string;
  admitResult: string;
}

// 弹窗入参
interface ModifyConfirmStatusModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (status:any) => void;
  studentInfo: any;
}

const ModifyConfirmStatusModal: React.FC<ModifyConfirmStatusModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  studentInfo
}) => {
  const [form] = Form.useForm<{ registerConfirmStatus: any }>();

  // 弹窗打开初始化单选值
  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ registerConfirmStatus: studentInfo.registerConfirmStatus });
    }
  }, [visible, studentInfo, form]);

  // 提交
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values.registerConfirmStatus);
      onCancel();
    } catch (err) {
      message.warning('请选择报到确认状态');
    }
  };

  return (
    <Modal
      title="修改确认状态"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={620}
      className="modify-confirm-modal"
    >
      {/* 顶部考生信息栏 */}
      <div className="info-bar">
        <div className="row-item">
          <span>考生号: <span className='row-item-value' title={studentInfo.candidateNumber||"--"}>{studentInfo.candidateNumber||"--"}</span></span>
          <span>姓名: <span className='row-item-value' title={studentInfo.userName||"--"}>{studentInfo.userName||"--"}</span></span>
          <span>联系电话:<span className='row-item-value' title={studentInfo.phone||"--"}>{studentInfo.phone||"--"}</span></span>
        </div>
        <div className="row-item">
          <span>手机:<span className='row-item-value' title={studentInfo.mobilePhone||"--"}>{studentInfo.mobilePhone||"--"}</span></span>
          <span>录取结果:<span className="green-text" title={studentInfo.majorCode||"--"}>{studentInfo.majorCode||"--"}</span></span>
        </div>
      </div>

      {/* 单选区域 */}
      <div className="form-wrap">
        <p className="label-text">会来学校报到确认状态:</p>
        <Form form={form} layout="vertical">
          <Form.Item name="registerConfirmStatus" rules={[{ required: true, message: '请选择状态' }]} noStyle>
            <Radio.Group>
              <Radio value={1}>确认会来</Radio>
              <Radio value={2}>确认不来</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </div>

      {/* 底部按钮 */}
      <div className="footer-btn-wrap">
        <Button type="primary" onClick={handleOk}>确定</Button>
        <Button onClick={onCancel}>取消</Button>
      </div>
    </Modal>
  );
};

export default ModifyConfirmStatusModal;